import { format, Locale } from "date-fns";

export const getFormatedDate = (date: string, locale: Locale) =>
  format(new Date(date), "dd MMMM, yyyy", { locale });
